import React from 'react';
import styled from 'styled-components';

import { Button } from 'src/presentation/components/agent_desktop_components';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import {
  StepDescription,
  StepWizardActionContainer,
  StepWizardField,
} from 'src/presentation/components/pages/email/components/StepWizardLayout';
import { useAddEmailAddress } from 'src/presentation/components/pages/email/hooks/useAddEmailAddress';

const renderModalDescription = isEditMode => {
  if (isEditMode) {
    return (
      <Note>
        <b>Note:</b> You can only change an email sender name. Email usernames and sending domains cannot be modified.
      </Note>
    );
  }

  return (
    <>
      <H3 data-aid="wizard-title">Enter email info</H3>
      <StepDescription data-aid="wizard-description">
        Enter an email address associated with a sending domain you want to send emails from Gladly.
      </StepDescription>
    </>
  );
};

const EmailDomainStep1 = ({
  item,
  errors,
  onCancel,
  setValue,
  nextStep,
  onSave,
  isEditMode,
}: {
  item?;
  onSave?;
  isEditMode?;
  emailAddresses?;
  errors?;
  nextStep?;
  onCancel?;
  setValue;
}): JSX.Element | null => {
  const nextStepHandler = value => {
    setValue(value);
    nextStep();
  };

  const { onEmailDomainSave, renderEmailDomainForm } = useAddEmailAddress({
    item,
    errors,
    isEditMode,
    onSaveSuccess: onSave || nextStepHandler,
  });

  return (
    <>
      <StepWizardField>
        {renderModalDescription(isEditMode)}
        {renderEmailDomainForm()}
      </StepWizardField>
      <StepWizardActionContainer>
        <Button onClick={onEmailDomainSave} data-aid="editor-save">
          {isEditMode ? 'Save' : 'Next'}
        </Button>
        <Button data-aid="editor-cancel" type={Button.Types.TEXT} onClick={onCancel}>
          Cancel
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

const Note = styled.p`
  text-align: left;
  margin-bottom: 24px;
`;

export default EmailDomainStep1;
